import React from "react";
//#region types
import { ExportItemProps } from "models/propTypes/revisorPropTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { Icon } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const ExportItem: React.FC<ExportItemProps> = (props) => {
  return (
    <Grid item container columnGap={1} className={cssExports.exportItem} direction="row" alignItems="center">
      <Icon
        icon={
          props.isDownloadAvailable ? IconDefinitionConstants.WValidateCheck : IconDefinitionConstants.WArrowSmallRight
        }
        className={clsx(
          cssExports.iconRoot,
          props.isDownloadAvailable ? cssExports.exportItemIconStatusDownload : cssExports.exportItemIconStatusQueued
        )}
      />

      <Grid item className={cssExports.exportItemText}>
        {props.itemText}
      </Grid>
      {props.itemSubtext && (
        <Grid item className={cssExports.exportItemSubText}>
          {props.itemSubtext}
        </Grid>
      )}
    </Grid>
  );
};

export default ExportItem;
